import { render, staticRenderFns } from "./Favorite.vue?vue&type=template&id=a2e46220&scoped=true&"
import script from "./Favorite.vue?vue&type=script&lang=js&"
export * from "./Favorite.vue?vue&type=script&lang=js&"
import style0 from "./Favorite.vue?vue&type=style&index=0&id=a2e46220&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e46220",
  null
  
)

export default component.exports